import { UserRole } from ".././model/user-role";
export class UserData {

    sequenceNumber: number;
    upn:string
    userId: string;
    firstName: string;
    lastName: string;
    intials: string;
    emailId: string;
    license: string;
    electronicSignatureAttestation: Date;
    usersRole: UserRole;
    roleId: number;
    language: string;
    userStatus: string;
    province:string;
    userRoleType: string;
    //SAVE OR UPDATE
    dcNumber:number[];
    storeNumber:string[];
    nctmAccess:boolean;
    

}


